<template>
  <ul class="chat-message-list">
    <li class="chat-message-list-item" v-for="message in messages" :key="message.messageId"
      :class="messageListItemClass(message)">
      <chat-question v-if="message.questionText" :question="message"></chat-question>
      <chat-message v-else :message="message"></chat-message>
    </li>
  </ul>
</template>

<script>
import ChatQuestion from './chat-question';
import ChatMessage from './chat-message';

const ChatMessageList = {
  name: 'ChatMessageList',

  components: {
    ChatQuestion,
    ChatMessage
  },

  props: {
    messages: {
      type: Array
    }
  },

  mounted() {
    this.scrollToLastItem();
  },

  updated() {
    // message was added
    this.scrollToLastItem();
  },

  methods: {
    messageListItemClass(message) {
      return {
        private: message.private,
        'to-all': message.toAll,
        question: message.questionText
      };
    },

    async scrollToLastItem() {
      await this.$nextTick(); // ensure all children are rendered
      const lastItem = this.$el.querySelector('.chat-message-list-item:last-child');
      if (lastItem) {
        lastItem.scrollIntoView();
      }
    }
  }
};

export default ChatMessageList;
</script>

<style lang="sass">
  .chat-message-list
    width: 100%
    -webkit-margin-before: 0
    -webkit-padding-start: 0
    -webkit-margin-after: 0
    padding: 0
    font-size: 0.9em

    li
      list-style-type: none

    .chat-message-list-item
      &+.chat-message-list-item
        margin: 8px 0
</style>
